import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/jobApplicationStats.module.css";

const MetricProgressBar = ({ label, value, max, color }) => {
  const safeValue = value || 0;

  const percentage = Math.min((safeValue / max) * 100, 100);

  return (
    <div className={styles.metricProgressItem}>
      <div className={styles.metricProgressLabel}>
        <span>{label}</span>
        <span>
          {safeValue}/{max}
        </span>
      </div>
      <div className={styles.progressBarContainer}>
        <div
          className={styles.progressBar}
          style={{ width: `${percentage}%`, backgroundColor: color }}
        ></div>
      </div>
    </div>
  );
};

const MetricsTab = ({ stats, metrics }) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate("/pricing");
  };

  return (
    <div className={styles.metricsContainer}>
      <div className={styles.metricsGrid}>
        <div className={styles.metricCard}>
          <h4>Wellfound Automation Limits</h4>
          <MetricProgressBar
            label="Daily Applications"
            value={stats.dailyCount}
            max={50}
            color="#6c34ec"
          />
          <MetricProgressBar
            label="Monthly Goal"
            value={stats.monthlyCount}
            max={500}
            color="#10b981"
          />
        </div>
        <div className={styles.metricCard}>
          <h4>Account Status</h4>
          <div className={styles.accountStatus}>
            <div className={styles.statusItem}>
              <i
                className={`fas ${stats.isPremium ? "fa-crown" : "fa-user"}`}
              ></i>
              <span>
                Type: <strong>{stats.isPremium ? "Premium" : "Free"}</strong>
              </span>
            </div>
            <div className={styles.statusItem}>
              <i className="fas fa-paper-plane"></i>
              <span>
                Total Sent: <strong>{stats.totalApplications}</strong>
              </span>
            </div>
            <div className={styles.statusItem}>
              <i className="fas fa-coins"></i>
              <span>
                Credits: <strong>{stats.availableJobs}</strong>
              </span>
            </div>
          </div>
          {!stats.isPremium && (
            <button
              className={styles.upgradeButton}
              onClick={handleUpgradeClick}
            >
              <i className="fas fa-bolt"></i> Upgrade Plan
            </button>
          )}
        </div>
      </div>

      <div className={styles.recommendationsSection}>
        <h3 className={styles.sectionTitle}>Status & Tips</h3>
        <div className={styles.recommendationsList}>
          {stats.dailyCount === 0 ? (
            <div className={styles.recommendationItem}>
              <i
                className="fas fa-play-circle"
                style={{ color: "#6c34ec" }}
              ></i>
              <p>
                Ready to start? Go to <strong>Assistant Setup</strong> and click
                Start Automation.
              </p>
            </div>
          ) : (
            <div className={styles.recommendationItem}>
              <i
                className="fas fa-check-circle"
                style={{ color: "#10b981" }}
              ></i>
              <p>Awesome! You have applied to {stats.dailyCount} jobs today.</p>
            </div>
          )}

          {stats.availableJobs < 10 && (
            <div className={styles.recommendationItem}>
              <i
                className="fas fa-exclamation-triangle"
                style={{ color: "#ef4444" }}
              ></i>
              <p>
                Low credits warning. You have {stats.availableJobs} credits
                remaining.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricsTab;
